import { render, staticRenderFns } from "./UfPerformance.vue?vue&type=template&id=13ec9109&scoped=true"
import script from "./UfPerformance.vue?vue&type=script&lang=js"
export * from "./UfPerformance.vue?vue&type=script&lang=js"
import style0 from "./UfPerformance.vue?vue&type=style&index=0&id=13ec9109&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ec9109",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13ec9109')) {
      api.createRecord('13ec9109', component.options)
    } else {
      api.reload('13ec9109', component.options)
    }
    module.hot.accept("./UfPerformance.vue?vue&type=template&id=13ec9109&scoped=true", function () {
      api.rerender('13ec9109', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/collectionOperationDashboard/component/UfPerformance.vue"
export default component.exports